// Verbatim from handover — unchanged

/** Format a YYYY-MM-DD date to DD/MM/YYYY */
export function formatPortalDate(dateStr: string): string {
  if (!dateStr) return '—';
  const [y, m, d] = dateStr.split('-');
  if (!y || !m || !d) return dateStr;
  return `${d}/${m}/${y}`;
}

/** Calculate nights between two YYYY-MM-DD dates */
export function calcNights(arrival: string, departure: string): number {
  const a = new Date(arrival);
  const d = new Date(departure);
  return Math.round((d.getTime() - a.getTime()) / 86400000);
}

/** Today as YYYY-MM-DD */
export function todayISO(): string {
  return new Date().toISOString().split('T')[0];
}

/** Parse a DD/MM/YYYY or D/M/YYYY string to a Date for sorting */
export function parseDMY(dateStr: string | null): Date {
  if (!dateStr) return new Date(0);
  const parts = dateStr.split('/');
  if (parts.length === 3) {
    const [d, m, y] = parts;
    const year = y.length === 2 ? `20${y}` : y;
    return new Date(`${year}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`);
  }
  return new Date(dateStr);
}

/** Check if a date string (DD/MM/YYYY) is in the future */
export function isFutureDMY(dateStr: string | null): boolean {
  if (!dateStr) return false;
  const d = parseDMY(dateStr);
  return d >= new Date(new Date().toDateString());
}
